import React from 'react';

import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
  Badge,
  HStack,
  Text,
} from '@chakra-ui/react';

import { VERIFIED_EBAY_SELLER } from '../constants/defaultListingFieldsConfig';

const VerifiedSellerContent = ({ verifiedSeller }) => {
  const seller = verifiedSeller ?? VERIFIED_EBAY_SELLER;

  return (
  <Alert
    status="info"
    variant="left-accent"
    borderRadius="lg"
    alignItems="flex-start"
    py={4}
  >
    <AlertIcon mt={1} />
    <Box flex={1}>
      <AlertTitle fontSize="md" mb={1}>
        Verified eBay reference seller
      </AlertTitle>
      <AlertDescription fontSize="sm">
        Listing creation uses reference listing data from{' '}
        <Badge colorScheme="blue" fontSize="sm" mx={1}>
          {seller.username}
        </Badge>
        ({seller.label ?? 'Verified seller'}) as the template when searching, validating, and
        compiling new listings.
        {seller.description ?? VERIFIED_EBAY_SELLER.description}
      </AlertDescription>
      <HStack mt={2} spacing={2} flexWrap="wrap">
        <Badge colorScheme="green" variant="subtle">
          Verified source
        </Badge>
        <Text fontSize="xs" color="gray.600">
          Supplier SKU → Partslink mapping is required before each run.
        </Text>
      </HStack>
    </Box>
  </Alert>
  );
};

export default VerifiedSellerContent;
